<div class="lvi-content">
    <div class="avatar" [ngClass]="{ 'warning': data.listeAlertes?.niveau == 1,'danger': data.listeAlertes?.niveau == 2 }" [nSelector]="{ liste: liste,item: data,isNotSelectable: !extraOptions.isLotCreation }"><i class="icon-avance_2 nio"></i></div>
    <div class="lvi-body">
        <div class="title">
            <a [routerLink]="" (click)="navigateTo(LotItemType.AVANCE, data.idAvance)" class="fw-bold">
                {{ data.idAvance || ('avance.liste.numeroNonDefini' | translate) }} - {{ data.libelleObjet || ('lot.detail.listes.objetNonDefini' | translate) }}
            </a>
        </div>
        <ul class="lvi-attrs">
            <li><strong [translate]="'lot.detail.listes.montant'"></strong>{{ ((data.montant ? data.montant : 0) + (data.montantLettre ? data.montantLettre : 0)) | montant: data.devise?.code }}</li>
            <li><strong [translate]="'lot.detail.listes.contrepartie'"></strong>{{ ((data.montant ? data.montant : 0) + (data.montantLettre ? data.montantLettre : 0)) * data.taux | montant: this.settings?.deviseEntreprise }}</li>
            <li><strong [translate]="'lot.detail.listes.user'"></strong>{{ data.user | user}}</li>
            <li *ngIf="data.od?.idOd" (click)="openOd(data.od.idOd)" class="clickable">
                <strong [translate]="'lot.detail.listes.od'"></strong>
                {{ data.od.idOd }}
                <mat-icon color="primary" style="font-size:1.1em;">open_in_new</mat-icon>
            </li>
            <li><strong [translate]="'lot.detail.listes.type'"></strong>{{ data.nature }}</li>
            <li *ngIf="data.listeAlertes" (click)="showListeAlertes()" class="clickable"
                [ngClass]="{'back-danger' : data.listeAlertes.niveau == 2, 'back-warning' : data.listeAlertes.niveau == 1}">
                <strong [translate]="'workflow.alerte.title'"></strong><span>{{ ('workflow.alerte.niveau.' + data.listeAlertes.niveau | translate) }}</span>
            </li>
        </ul>
    </div>
    <div class="info">
        <statut *ngIf="data.statut?.image" [statut]="data.statut"></statut>
    </div>
</div>
